import { CustomLabel } from "../../../layouts/customLabel";
import { FormInputClass } from "../../../layouts/FormInputClass";
import { Add, Remove } from "../../../layouts/icons";

const MerchFrom = ({
  form,
  handleChange,
  fieldErrors,
  previews,
  fileInputRef,
  handleFiles,
  removeFile,
}) => {
  return (
    <>
      {/* ── Item details ── */}
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-2 gap-4">
          {/* Item name */}
          <div>
            <CustomLabel text="Item name" required />
            <input
              name="item_name"
              className={FormInputClass(fieldErrors.item_name)}
              placeholder="e.g. Branded tote bag"
              value={form.item_name}
              onChange={handleChange}
            />
            {fieldErrors.item_name && (
              <p className="text-xs text-red-400 mt-1">
                {fieldErrors.item_name}
              </p>
            )}
          </div>

          {/* Stock count */}
          <div>
            <CustomLabel text="Stock count" required />
            <input
              name="item_count"
              type="number"
              min="0"
              className={FormInputClass(fieldErrors.item_count)}
              placeholder="0"
              value={form.item_count}
              onChange={handleChange}
              onWheel={(e) => e.target.blur()}
            />
            {fieldErrors.item_count && (
              <p className="text-xs text-red-400 mt-1">
                {fieldErrors.item_count}
              </p>
            )}
          </div>
        </div>

        {/* Purpose */}
        <div>
          <CustomLabel text="Description/Purpose" />
          <textarea
            name="item_purpose"
            rows={2}
            className={FormInputClass(fieldErrors.item_purpose)}
            placeholder="e.g. Client gifting, trade events"
            value={form.item_purpose}
            onChange={handleChange}
          />
          {fieldErrors.item_purpose && (
            <p className="text-xs text-red-400 mt-1">
              {fieldErrors.item_purpose}
            </p>
          )}
        </div>

        <div>
          <CustomLabel text="Storage Location" required />
          <select
            name="storage_location"
            id="storage-location"
            value={form.storage_location ?? ""}
            onChange={handleChange}
            className={FormInputClass(fieldErrors.storage_location)}
          >
            <option value="" disabled>
              Select storage location
            </option>
            <option value="melb">Melbourne</option>
            <option value="syd">Sydney</option>
          </select>

          {fieldErrors.storage_location && (
            <p className="text-xs text-red-400 mt-1">
              {fieldErrors.storage_location}
            </p>
          )}
        </div>

        <div>
          <CustomLabel text="Storage" />
          <textarea
            name="item_location"
            rows={2}
            className={FormInputClass(fieldErrors.item_location)}
            placeholder="e.g. Locker 01"
            value={form.item_location}
            onChange={handleChange}
          />
          {fieldErrors.item_location && (
            <p className="text-xs text-red-400 mt-1">
              {fieldErrors.item_location}
            </p>
          )}
        </div>
      </div>

      <div>
        <CustomLabel text="Restock expected" />
        <div className={FormInputClass(false)}>
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="restock_expected"
              name="restock_expected"
              checked={form.restock_expected ?? false}
              onChange={handleChange}
              className="w-4 h-4 accent-primary"
            />
            <label
              htmlFor="restock_expected"
              className="text-sm text-gray-700 dark:text-gray-300 cursor-pointer select-none"
            >
              Item will be restocked
            </label>
          </div>
        </div>
      </div>
      {/* ── Images ── */}
      <div className="flex flex-col gap-3">
        {/* Preview grid */}
        {previews.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {previews.map(({ fileName, objectUrl }) => (
              <div
                key={fileName}
                className="relative w-20 h-20 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 group shrink-0"
              >
                <img
                  src={objectUrl}
                  alt={fileName}
                  className="w-full h-full object-cover"
                />
                <button
                  type="button"
                  onClick={() => removeFile(fileName)}
                  className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <Remove />
                </button>
                <div className="absolute bottom-0 inset-x-0 bg-black/60 px-1 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                  <p className="text-white text-[9px] truncate">{fileName}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Upload button */}
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="flex items-center justify-center gap-2 w-full px-4 py-3 rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-700 text-sm text-gray-400 hover:border-primary hover:text-primary transition-colors"
        >
          <Add />
          {previews.length > 0 ? "Add more images" : "Add images"}
        </button>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept="image/*"
          className="hidden"
          onChange={handleFiles}
        />
        <p className="text-xs text-gray-400">
          {form.assets.length > 0
            ? `${form.assets.length} image${form.assets.length > 1 ? "s" : ""} selected`
            : "No images added — you can add them later"}
        </p>
      </div>
    </>
  );
};
export default MerchFrom;
